module.exports = __webpack_public_path__ + "img/551387D2-7D06-4089-BEBC-0E42D947EEC0_2_verpixelt.cbc9d43d.jpg";